/**
 * The Hall of Fame's memory and prefetch (shared/hall-memory.ts), over this client's API. The months
 * are kept in localStorage ("op.hall") with the household they belong to, the one flags-core.ts
 * keeps as op.lastHousehold, so a page load paints them at once; hall.forget() clears them.
 */
import { createHallMemory, hallStore } from "../shared/hall-memory.ts";
import { api } from "./api";

/** src/flags-core.ts LAST_HOUSEHOLD_KEY. */
const LAST_HOUSEHOLD_KEY = "op.lastHousehold";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* private mode etc.: the Hall still works, it just waits for its request */
  }
}

export const hall = createHallMemory(
  (tz) => api.stats.hall(tz),
  () => performance.now(),
  hallStore(read, write, () => read(LAST_HOUSEHOLD_KEY)),
);
